import { cardAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

var _a = createMultiStyleConfigHelpers(cardAnatomy.keys), definePartsStyle = _a.definePartsStyle, defineMultiStyleConfig = _a.defineMultiStyleConfig;
var plain = definePartsStyle({
    container: {
        border: 1,
        boxShadow: 'shadow-low',
        borderRadius: 'md'
    }
});
var outline = definePartsStyle({
    container: {
        border: 1,
        borderStyle: 'solid',
        borderColor: 'neutrals.300 !important',
        boxShadow: 'shadow-low',
        borderRadius: 'md'
    }
});
var sizes = defineStyle({
    md: {
        body: {
            p: '4'
        }
    },
    lg: {
        body: {
            p: '5'
        }
    }
});
var cardTheme = defineMultiStyleConfig({
    defaultProps: {
        size: 'lg',
        variant: 'plain'
    },
    variants: { plain: plain, outline: outline },
    sizes: sizes
});

export { cardTheme };
//# sourceMappingURL=card.js.map
